bovoApp.
factory('Pallette', ['$http', function($http) {
    return {
      all: function(data) {
        return $http.post('api/pallettes', data);
      },
      get: function(id) {
        return $http.get('api/pallette/' + id);
      },
      new: function(id) {
        return $http.get('api/new-pallette');
      },
      delete: function(id) {
        return $http.delete('api/delete-pallette/' + id);
      },
      save: function(data) {
        return $http.post('api/save-pallette',data);
      },
      update: function(data) {
        return $http.post('api/update-pallette',data);
      }
    };
}]);